<script setup lang="ts">
import type { ISkuSelectorOption } from '../models';
import { MMText } from '@mm-frontend/mm-web-ui-kit';

defineProps<{ option: ISkuSelectorOption; isActive?: boolean; isUnavailable?: boolean }>();
</script>

<template>
  <div
    class="sku-option-color"
    :class="{
      'sku-option-color_active': isActive,
      'sku-option-color_unavailable': isUnavailable,
    }"
  >
    <div :style="{ background: option.value }" />
  </div>
</template>

<style scoped lang="stylus">
.sku-option-color
  box-sizing border-box
  width 44px
  height 44px
  border-radius 50%
  cursor pointer
  display flex
  align-items center
  justify-content center
  background-color #ffffff
  overflow hidden
  transition-duration .1s
  border solid 1px var(--border-regular)

  & > div
    width 100%
    height 100%
    background-color #EFEFEF
    background-position center
    background-size 100%
    background-repeat no-repeat
    position relative
    overflow hidden
    display flex
    align-items center
    justify-content center
    border-radius 50%

  &_active
    outline solid 2px var(--border-focused)
    outline-offset -2px
    padding 4px

  &_unavailable
    & > div
      opacity .7
      &::after
        content ''
        background-color var(--border-disabled)
        border solid 1px #FFFFFF
        position absolute
        transform rotateZ(-35deg)
        height 44px
        width 1px
</style>
